import { Injectable } from '@angular/core';
import { settingsObjectStore } from './object-stores/object-stores';

@Injectable({
  providedIn: 'root',
})
export class IndexedDBService {
  public static readonly objectStores = [settingsObjectStore];
  private static readonly dbName = 'nadapp';
  private static readonly dbVersion = 1;
  private static db: IDBDatabase | null = null;

  async getDB(): Promise<IDBDatabase> {
    if (IndexedDBService.db) return IndexedDBService.db;
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(
        IndexedDBService.dbName,
        IndexedDBService.dbVersion,
      );

      request.onupgradeneeded = () => {
        const db = request.result;
        IndexedDBService.db = db;
        for (const objectStore of IndexedDBService.objectStores) {
          console.debug(
            `Initialize db ${IndexedDBService.dbName} with objectstore ${objectStore.objectStoreName}`,
          );
          db.createObjectStore(objectStore.objectStoreName, {
            keyPath: objectStore.keyPath,
          });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
}
